import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { useHistory, useParams } from "react-router-dom";

import Loader from "../../../components/general/loader/Loader";
import IndeedEditCampaignForm from "../../../components/indeed-manager/IndeedEditCampaignForm";
import usePageInitialization from "../../../hooks/usePageInitialization";
import { RootStoreContext } from "../../../stores/RootStoreContext";
import { SupervisionBreadcrumbs } from "../supervision/breadcrumbs/supervision.breadcrumbs";
import { IndeedContextInitializers } from "./helpers/IndeedContextInitializers";
import { IndeedBreadcrumbs } from "./helpers/IndeedManager.breadcrumbs";

interface Props {}

const IndeedEditCampaignPage = (props: Props) => {
    const match = useParams<{ campaignId: string; indeedCampaignId: string }>();
    const history = useHistory();
    const { indeedStore } = useContext(RootStoreContext);

    usePageInitialization({
        onInitAsync: async () => {
            await IndeedContextInitializers.InitializePLCampaignData(
                Number(match.campaignId),
                indeedStore,
                history
            );
            await IndeedContextInitializers.InitializeSelectedIndeedCampaign(
                match.indeedCampaignId,
                indeedStore.PLCampaignData!,
                indeedStore,
                history
            );
        },
        onCompanyContextCallBack: (company, uiStore) => {
            uiStore.SetPageTitle(
                `Edit Indeed Campaign: ${indeedStore.SelectedIndeedCampaign?.name}`
            );
            uiStore.AddBreadCrumbs(
                SupervisionBreadcrumbs.Companies(company.companyName),
                SupervisionBreadcrumbs.Campaigns(`${indeedStore.PLCampaignData?.indeedCampaignSourceInfo.campaignName}`),
                IndeedBreadcrumbs.Indeed(Number(indeedStore.PLCampaignData?.indeedCampaignSourceInfo.campaignID)),
                IndeedBreadcrumbs.IndeedCampaign(
                    indeedStore.SelectedIndeedCampaign?.name ?? ""
                ),
                IndeedBreadcrumbs.EditCampaign(
                    Number(indeedStore.PLCampaignData?.indeedCampaignSourceInfo.campaignID),
                    match.indeedCampaignId
                )
            );
        },
    });

    if (!indeedStore.SelectedIndeedCampaign) {
        return <Loader position="normal" />;
    }

    return (
        <div>
            <IndeedEditCampaignForm
                plCampaignId={Number(match.campaignId)}
                indeedCampaign={indeedStore.SelectedIndeedCampaign}
            />
        </div>
    );
};

export default observer(IndeedEditCampaignPage);
